<template>
  <div>
    <page-title title="Testing Notes" />
    <hr />

    <b-row>
      <b-col>
        <!-- <h2>What's Working</h2>
        <ul>
          <li>Auth</li>
          <li>
            Subscriber experience
            <ul>
              <li>Create a new client</li>
            </ul>
          </li>
          <li>
            Client experience
            <ul>
              <li>Receive invitation email and SMS</li>
              <li>Initial landing page</li>
              <li>Account/password creation</li>
              <li>Form navigation</li>
              <li>Form completion</li>
            </ul>
          </li>
        </ul> -->

        <!-- <h2>To Do</h2>
        <ul>
          <li>
            Subscriber experience
            <ul>
              <li>Dashboard</li>
              <li>Registration</li>
              <li>Client list</li>
              <li>Client summary</li>
              <li>Report generation/download</li>
            </ul>
          </li>
          <li>
            Client experience
            <ul>
              <li>Form validation</li>
              <li>Form conditional logic</li>
              <li>Additional assessments/questionnaire pages</li>
              <li>File uploads</li>
            </ul>
          </li>
        </ul> -->

      <!-- </b-col>
      <b-col> -->

        <!-- <h2>Questions</h2>
        <ul>
          <li>After a client finishes the forms, should there be any sort of review or confirmation? Any confirmation email to the client?</li>
          <li>After a client finishes the forms, can they go back and edit them in the future? Or are they now locked?</li>
          <li>What sort of validation do we need on the forms? Are all fields required? Only some?</li>
          <li>Do we want single sign-on with Google or Facebook for subscribers?</li>
          <li>Monthly vs. annual billing</li>
          <li>Will all clients have either phone or email? Will they have both?</li>
          <li>Subscriber dashboard: two-column/split view?</li>
          <li>Terminology/taxonomy to use: subscriber/attorney, client, questionnaire, assessment, etc.</li>
          <li>Add instructions up front, or modify examples, to use third person?</li>
          <li>Read-only DOCX vs. PDF?</li>
        </ul> -->

        <h2>Test Accounts</h2>
        <ul>
          <li>attorney1@test.com / abcd1234</li>
        </ul>

      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TestingNotes',
  props: {
  }
}
</script>